// extracted by mini-css-extract-plugin
export default {"volunteerContainer":"Volunteer_volunteerContainer__zTGMa","text":"Volunteer_text__WHmz4","iconLink":"Volunteer_iconLink__ndDuv","icon":"Volunteer_icon__6Fr6W"};